import { render, staticRenderFns } from "./ValidatedGroup.vue?vue&type=template&id=054dae25"
import script from "./validatedGroup.ts?vue&type=script&lang=ts&external"
export * from "./validatedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054dae25')) {
      api.createRecord('054dae25', component.options)
    } else {
      api.reload('054dae25', component.options)
    }
    module.hot.accept("./ValidatedGroup.vue?vue&type=template&id=054dae25", function () {
      api.rerender('054dae25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/buttons-group/groups/manager/validated-group/ValidatedGroup.vue"
export default component.exports